<div
  class="flex items-center gap-2 rounded border border-error-container bg-white py-2 pl-3 pr-1"
  role="alert">
  <mat-icon class="material-symbols-outlined !flex !items-center shrink-0 !text-error !text-2xl">error</mat-icon>
  <p class="label-large flex-1 text-on-primary-container m-0">
    {{ 'Failed to regenerate this document' | translate }}
  </p>
  <button
    mat-button
    type="button"
    class="shrink-0 text-primary"
    [disabled]="disabled"
    (click)="retry.emit()">
    {{ 'Try again' | translate }}
  </button>
  <button
    mat-icon-button
    type="button"
    class="shrink-0 text-on-surface-variant"
    [attr.aria-label]="'Close' | translate"
    (click)="dismiss.emit()">
    <mat-icon>close</mat-icon>
  </button>
</div>
